const UploadSummary = ({ result }) => {
  if (!result?.upload) {
    return null;
  }

  const {
    uploadType,
    totalRecords = 0,
    successfulRecords = 0,
    failedRecords = 0,
    status,
    errorMessages = [],
  } = result.upload;

  const isSuccess = status === "completed" && failedRecords === 0;

  const isPartialSuccess = status === "completed" && failedRecords > 0;

  const isFailed = status === "failed";

  const headerClass = isSuccess
    ? "summary-header success"
    : isFailed
      ? "summary-header error"
      : "summary-header warning";

  const title = isSuccess
    ? "Upload Completed Successfully"
    : isFailed
      ? "Upload Failed"
      : "Upload Completed With Errors";

  return (
    <div className="upload-summary">
      <div className={headerClass}>
        <h3>{title}</h3>
      </div>

      <div className="summary-cards">
        <div className="summary-card">
          <h4>Upload Type</h4>

          <p>{uploadType === "questionBank" ? "Question Bank" : "Quiz"}</p>
        </div>

        <div className="summary-card">
          <h4>Total Records</h4>

          <p>{totalRecords}</p>
        </div>

        <div className="summary-card success-card">
          <h4>Successful</h4>

          <p>{successfulRecords}</p>
        </div>

        <div className="summary-card error-card">
          <h4>Failed</h4>

          <p>{failedRecords}</p>
        </div>
      </div>

      {isPartialSuccess && (
        <div className="error-info">
          <p>
            {failedRecords} question
            {failedRecords > 1 ? "s" : ""} could not be uploaded.
          </p>

          {errorMessages.length > 0 && (
            <p>Please review the error details below.</p>
          )}
        </div>
      )}

      {isFailed && (
        <div className="error-info">
          <p>The upload could not be processed.</p>

          {errorMessages.length > 0 && (
            <p>Please review the error details below.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default UploadSummary;
